try {
    let header = document.querySelector(".header")
    let headerBtn = document.querySelector(".header__fixedBtnsBurger")
    let headerMenu = document.querySelector(".header__menu")
    let headerMenuInnerUlLi = headerMenu.querySelectorAll(".header__menuInnerBlock>ul>li")

    headerBtn.addEventListener("click", () => {
        header.classList.toggle("is-on");
        noscroll(header.classList.contains("is-on"))
    })

    headerMenu.addEventListener("click", (e) => {
        if (e.currentTarget === e.target) {
            header.classList.remove("is-on");
            noscroll(header.classList.contains("is-on"))
        }
    })

    headerMenuInnerUlLi.forEach((li) => {
        li.addEventListener("click", () => {
            header.classList.remove("is-on");
            noscroll(header.classList.contains("is-on"))
        })
    })

    function noscroll(bool) {
        if (bool) {
            document.addEventListener('touchmove', disableScroll, {
                passive: false
            });
            document.addEventListener('mousewheel', disableScroll, {
                passive: false
            });
        } else {
            document.removeEventListener('touchmove', disableScroll, {
                passive: false
            });
            document.removeEventListener('mousewheel', disableScroll, {
                passive: false
            });
        }
    }

    function disableScroll(event) {
        event.preventDefault();
    }
} catch (error) {

}